import {
  isApiEntity,
  isComponentEntity,
  isDomainEntity,
  isGroupEntity,
  isResourceEntity,
  isSystemEntity,
  isUserEntity,
} from '@backstage/catalog-model';
import {
  BreadcrumbConfig,
  RelatedEntityExtractor,
} from '@internal/backstage-plugin-api-catalog';
import { isEntity } from '@internal/backstage-plugin-api-catalog-common';

const systemOfEntity: RelatedEntityExtractor = {
  referenceExtractor: entity =>
    entity && entity.spec && typeof entity.spec.system === 'string'
      ? entity.spec.system
      : null,
  fallbackKind: 'system',
};

const domainOfEntity: RelatedEntityExtractor = {
  referenceExtractor: entity =>
    entity && entity.spec && typeof entity.spec.domain === 'string'
      ? entity.spec.domain
      : null,
  fallbackKind: 'domain',
};

const parentDomainOfEntity: RelatedEntityExtractor = {
  referenceExtractor: entity =>
    isEntity(entity) && isDomainEntity(entity) ? entity.spec.subdomainOf : null,
  fallbackKind: 'domain',
};

const parentGroupExtractor: RelatedEntityExtractor = {
  referenceExtractor: entity =>
    isEntity(entity) && isGroupEntity(entity) ? entity.spec.parent : null,
  fallbackKind: 'group',
};

export const breadcrumbDefinitions: ReadonlyArray<BreadcrumbConfig> = [
  /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   *  handle the main kinds as fallback, do not move before the concrete
   * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

  {
    entityMatcher: isApiEntity,
    previousEntityExtractor: systemOfEntity,
  },

  {
    entityMatcher: isComponentEntity,
    previousEntityExtractor: systemOfEntity,
  },

  {
    entityMatcher: isDomainEntity,
    previousEntityExtractor: parentDomainOfEntity,
  },

  {
    entityMatcher: isGroupEntity,
    previousEntityExtractor: parentGroupExtractor,
  },

  {
    entityMatcher: isResourceEntity,
    previousEntityExtractor: systemOfEntity,
  },

  {
    entityMatcher: isSystemEntity,
    previousEntityExtractor: domainOfEntity,
  },

  {
    entityMatcher: isUserEntity,
  },
];
